import { CircularProgress, InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { RiArrowDownSLine } from "react-icons/ri";

export const useStyles = makeStyles(() => ({
    paper: {
        backgroundColor: "#1F2A37",
        color: "#D1D5DB",
    },
    option: {
        "&:hover": {
            backgroundColor: "#374151 !important",
        },
    },
    noOptions: {
        color: "#fff",
    },
    clearIndicator: {
        color: "#6B7280",
    },
    popupIndicator: {
        color: "#6B7280",
    },
    endAdornment: {
        top: "unset",
    },
}));

/**
 * @see https://v4.mui.com/components/autocomplete/
 */
const CustomAutocomplete = ({
    variant,
    label,
    margin,
    name,
    handleBlur,
    handleFocus,
    handleChange,
    handleInputChange,
    value,
    error,
    errors,
    helperText,
    placeholder,
    required,
    disabled,
    readOnly,
    options,
    noOptionsText,
    getOptionLabel,
    style,
    freeSolo,
    loading,
    handleFilterOptions,
    InputLabelProps,
    inputProps,
    InputProps,
    inputValue,
    touched,
    inheritLabel,
    className,
    multiple,
    disableCloseOnSelect,
    ChipProps,
    ...props
}) => {
    const classes = useStyles();

    return (
        <div className="d-flex flex-column gap-8">
            {label && !inheritLabel && typeof label === "string" ? (
                <span title={label} className="tt-14 medium color-dark-7 overflow-ellipsis w-100 text-left" htmlFor={name}>
                    {label}
                    {required ? <span className="color-red"> *</span> : ""}
                </span>
            ) : (
                label
            )}

            <Autocomplete
                openOnFocus
                ChipProps={ChipProps}
                disableCloseOnSelect={disableCloseOnSelect}
                multiple={multiple}
                name={name}
                required={required}
                disabled={disabled}
                readOnly={readOnly}
                noOptionsText={loading ? "Carregando..." : (noOptionsText ?? "Sem resultados.")}
                value={value}
                onChange={handleChange}
                inputValue={inputValue}
                onInputChange={handleInputChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                options={loading ? [] : options}
                getOptionLabel={getOptionLabel}
                placeholder={options?.length && value?.length ? "" : placeholder}
                freeSolo={freeSolo}
                filterOptions={handleFilterOptions}
                popupIcon={<RiArrowDownSLine />}
                className={className}
                classes={{
                    paper: classes.paper,
                    option: classes.option,
                    noOptions: classes.noOptions,
                    clearIndicator: classes.clearIndicator,
                    popupIndicator: classes.popupIndicator,
                    endAdornment: classes.endAdornment,
                }}
                {...props}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={inheritLabel && label ? label : null}
                        margin={margin || "dense"}
                        variant={variant || "outlined"}
                        helperText={helperText || (name && touched[name] ? errors[name] : null)}
                        error={error || (name ? Boolean(touched[name] && errors[name]) : false)}
                        placeholder={options?.length && value?.length ? "" : placeholder}
                        required={required}
                        disabled={disabled}
                        readOnly={readOnly}
                        style={{ margin: 0, marginTop: inheritLabel ? 24 : 0, ...style }}
                        InputProps={
                            loading
                                ? {
                                      ...params.InputProps,
                                      ...InputProps,
                                      endAdornment: (
                                          <InputAdornment position="end">
                                              <CircularProgress size={15} />
                                          </InputAdornment>
                                      ),
                                  }
                                : {
                                      ...params.InputProps,
                                      ...InputProps,
                                  }
                        }
                        InputLabelProps={InputLabelProps}
                        inputProps={{
                            ...params.inputProps,
                            ...inputProps,
                        }}
                    />
                )}
            />
        </div>
    );
};

export default CustomAutocomplete;
